module.exports = __webpack_public_path__ + "static/media/San Kim.eb745c3f.png";